import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_SYNC, SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/roomType'

export const roomTypeService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    translate,
    syncGallery,
};

//search
// function search(offset, max, data, fbDB) {
//     const udn  = JSON.parse( localStorage.getItem('selectedUdn') )
//     return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}&udn=${udn?.id}&fbDB=${fbDB}`, 'POST', { data: data, showAlert:false })
// }
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data:data, showAlert:false })
}

//show
function getItem(id, fbDataBase) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDataBase}`, 'GET', {showAlert:false})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data:data});
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data:data});
}

//delete
function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}

function syncGallery(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncGallery`, 'POST', { data, message: SUCCESSFUL_SYNC });
}